import { render, staticRenderFns } from "./FormJournal.vue?vue&type=template&id=57712d0a"
import script from "./FormJournal.vue?vue&type=script&lang=js"
export * from "./FormJournal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports